'use strict';

exports.__esModule = true;

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-console */

/**
 * Global name for error
 * @ignore
 */
var name = 'QuiqupJS';

function Logger() {}
var logger = new Logger();

Logger.prototype.warn = function () {
  var _console;

  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var message = '[' + name + ' warn]';
  if (process.env.NODE_ENV !== 'production') (_console = console).warn.apply(_console, [message].concat(args));
};

Logger.prototype.info = function () {
  var _console2;

  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  var message = '[' + name + ' info]';
  if (process.env.NODE_ENV !== 'production') (_console2 = console).info.apply(_console2, [message].concat(args));
};

Logger.prototype.debug = function () {
  var _console3;

  for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  var message = '[' + name + ' debug]';
  if (process.env.NODE_ENV !== 'production') (_console3 = console).debug.apply(_console3, [message].concat(args));
};

Logger.prototype.log = function () {
  var _console4;

  for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    args[_key4] = arguments[_key4];
  }

  var message = '[' + name + ' log]';
  if (process.env.NODE_ENV !== 'production') (_console4 = console).log.apply(_console4, [message].concat(args));
};

Logger.prototype.error = function (description) {
  var message = '[' + name + ' error] ' + description;
  throw new QUError(message);
};

Logger.prototype.deprecate = function (oldFunction, newFunction) {
  logger.debug(oldFunction + ' has been replaced with ' + newFunction + ' in latest version.');
};

/**
 * Wraps native Error with additional information
 * @ignore
 */
function QUError(message) {
  this.name = name;
  this.message = message || 'Unhandled Error in QuiqupJS';
  this.stack = new Error().stack;
}

QUError.prototype = (0, _create2.default)(Error.prototype);
QUError.prototype.constructor = QUError;

exports.default = logger;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/utils/qu-log.js
// module id = 279
// module chunks = 0